import script from "./AccountVerificationResendModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountVerificationResendModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountVerificationResendModal.vue?vue&type=style&index=0&id=68b73232&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b73232"]])

export default __exports__